import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Container } from '@mui/material';
import { ErrorOutline as ErrorIcon, ExploreOff as MissingIcon } from '@mui/icons-material';
import EmptyState from './EmptyState';

/**
 * What a page shows instead of its content when it can't show it:
 *
 * - kind="error": loading failed. "Try again" reloads the page.
 * - kind="missing": the record doesn't exist (or isn't shared with this user).
 *
 * `backTo` / `backLabel` add a way out (the main button for "missing", a
 * secondary one for "error"). `action` replaces the buttons entirely.
 */
const PageState = ({ kind = 'error', title, description, backTo, backLabel = 'Back to surveys', action }) => {
  const missing = kind === 'missing';
  const back = backTo && (
    <Button component={RouterLink} to={backTo} variant={missing ? 'contained' : 'text'} color={missing ? 'primary' : 'inherit'}>
      {backLabel}
    </Button>
  );
  const buttons = action ?? (missing ? back : (
    <>
      <Button variant="contained" onClick={() => window.location.reload()}>Try again</Button>
      {back}
    </>
  ));
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
      <EmptyState
        icon={missing ? MissingIcon : ErrorIcon}
        tone={missing ? 'primary' : 'error'}
        title={title}
        description={description}
        action={buttons}
      />
    </Container>
  );
};

export default PageState;
